export default class Account {
  accountNumber;
  classification;
  dateCreated;
  dayTrader;
  optionLevel;
  status;
  type;
  lastUpdateDate;

  constructor({ accountNumber, classification, dateCreated, dayTrader, optionLevel, status, type, lastUpdateDate }) {
    this.accountNumber = accountNumber;
    this.classification = classification;
    this.dateCreated = new Date(dateCreated);
    this.dayTrader = dayTrader;
    this.optionLevel = optionLevel;
    this.status = status;
    this.type = type;
    this.lastUpdateDate = new Date(lastUpdateDate);
  }

  static fromJson(json) {
    return new Account({
      accountNumber: json.account_number,
      classification: json.classification
        .toString()
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase()),
      dateCreated: json.date_created,
      dayTrader: json.day_trader,
      optionLevel: json.option_level,
      status: json.status,
      type: json.type,
      lastUpdateDate: json.last_update_date,
    });
  }

  toString() {
    return `${this.accountNumber} - ${this.classification}`;
  }

  get maskedString() {
    return this.accountNumber.slice(-4);
  }
}
